<template>
  <div class="flex items-center h-full">
    <vs-chip :color="chipSettings.color" :transparent="chipSettings.transparent" size="small" class="h-4">
      {{ chipSettings.text }} {{ checkAmount }} / {{ totalAmount }}</vs-chip>
  </div>
</template>
<script>
import Vue from 'vue'
import { PROVISIONAL_MONTH } from '../../utils/strings'
export default Vue.extend({
  data() {
    return {
      totalAmount: 0,
      checkAmount: 0,
      chipSettings: {
        transparent: true,
        color: 'dark',
        text: '-'
      }
    }
  },
  beforeMount() {
    const { labelChip, field } = this.params  //Variants now are billing and charges, add payment
    this.chipSettings.text = labelChip
    const cellValue = this.params.value
    const { files, is_programmatic } = cellValue
    let filteredFiles = files.filter(file => !file.canceled_at)

    if(is_programmatic){
      filteredFiles = filteredFiles.filter(file => file.month !== PROVISIONAL_MONTH)
    }


    this.totalAmount = filteredFiles.length
    this.checkAmount = filteredFiles.filter(file => file[field]).length
    this.setChipColor()
  },
  methods: {
    setChipColor() {
      if (this.totalAmount === 0) {
        this.chipSettings.color = 'dark'
      } else {
        this.chipSettings.transparent = false  
        if (this.checkAmount === 0) {
          this.chipSettings.color = 'danger'
        } else {
          if (this.checkAmount === this.totalAmount) {
            this.chipSettings.color = 'success'
          }
          if (this.checkAmount < this.totalAmount){
            this.chipSettings.color = 'warning'
          }
        }
      }
    }
  }
})
</script>
